import { useDispatch } from 'react-redux'
import { editIconSvg } from '../svg'
import EditCard from './edit-card'
import {
  messageBoxHideAction,
  messageBoxShowAction,
} from 'src/reducers/message-box/action'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import { ButtonActionType, ButtonData, ButtonType } from 'src/model/button'
import { patchCourseLandingPageAction } from 'src/reducers/course/action'

const CreateCollectionTemplate = (collections, dispatch, isEdit) => {
  if (collections) {
    const defaultImage =
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/Default.png'

    const ensureHttps = url => {
      if (!url) return defaultImage

      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        return `https://cdn.minicoursegenerator.com/${
          url.startsWith('/') ? url.substring(1) : url
        }`
      }

      return url
    }

    window.courseUpdateData = null
    window.collectionsData = [...collections]

    // Store current collection data in a better way
    window.editCollection = function (courseId) {
      // Find the current collection based on ID
      const currentCollection =
        window.collectionsData.find(c => c.id === Number(courseId)) || {}

      // Get current thumbnail and description directly from collectionsData
      const currentThumbnail = currentCollection.thumbnail || ''
      const currentDescription = currentCollection.description || ''

      // Set the update data with current values
      window.courseUpdateData = {
        id: courseId,
        landingPageSettings: {
          thumbnail: currentThumbnail,
          description: currentDescription,
        },
      }

      dispatch(
        messageBoxShowAction(
          MessageBoxContent({
            type: MessageBoxType.WARNING,
            buttons: [
              new ButtonData(
                ButtonType.NORMAL,
                'Cancel',
                ButtonActionType.NO,
                () => {
                  dispatch(messageBoxHideAction())
                },
              ),
              new ButtonData(
                ButtonType.ACTION,
                'Save',
                ButtonActionType.YES,
                () => {
                  if (window.courseUpdateData) {
                    dispatch(
                      patchCourseLandingPageAction(window.courseUpdateData.id, [
                        {
                          path: 'thumbnail',
                          value:
                            window.courseUpdateData.landingPageSettings
                              .thumbnail,
                        },
                        {
                          path: 'description',
                          value:
                            window.courseUpdateData.landingPageSettings
                              .description,
                        },
                      ]),
                    )

                    const collectionIndex = window.collectionsData.findIndex(
                      c => c.id === Number(window.courseUpdateData.id),
                    )
                    if (collectionIndex !== -1) {
                      const updatedCollection = {
                        ...window.collectionsData[collectionIndex],
                        thumbnail:
                          window.courseUpdateData.landingPageSettings.thumbnail,
                        description:
                          window.courseUpdateData.landingPageSettings
                            .description,
                      }

                      window.collectionsData[
                        collectionIndex
                      ] = updatedCollection

                      const collectionImage = document.querySelector(
                        `[data-course-id="${window.courseUpdateData.id}"] img`,
                      )
                      if (collectionImage) {
                        const newThumbnail =
                          updatedCollection.thumbnail === ''
                            ? defaultImage
                            : ensureHttps(updatedCollection.thumbnail)
                        collectionImage.src = newThumbnail
                      }

                      const collectionDescription = document.querySelector(
                        `[data-course-id="${window.courseUpdateData.id}"] .section-text`,
                      )
                      if (collectionDescription) {
                        collectionDescription.textContent =
                          updatedCollection.description || ''
                      }
                    }
                  }

                  dispatch(messageBoxHideAction())
                },
              ),
            ],
            title: `
                  <div style="display: flex; align-items: center; justify-content: center; gap: 8px; color: var(--mcg-dark, #002E47); font-family: Inter; font-size: 16px; font-weight: 400; line-height: 150%;">
            <Typography>Edit card</Typography>
          </div>
                `,
            component: (
              <EditCard
                thumbnailUrl={currentCollection.thumbnail || ''}
                description={currentCollection.description || ''}
                onSave={settings => {
                  window.courseUpdateData = {
                    id: courseId,
                    landingPageSettings: settings,
                  }
                }}
                setImageURL={() => {}}
              />
            ),

            maxWidth: '680px',
          }),
        ),
      )
    }

    return `     
      <div  class="collection-wrapper">
        ${collections
          .map(
            (course, index) => `
          <div class="${
            isEdit ? 'collection-container' : 'collection-container-preview'
          }" data-course-id="${course.id}" 
                  onclick="editCollection('${course.id}')">
            <div class="collection-inner-container">
              <div class="collection-sections-container">
                <div class="collection-section">
                  <div class="collection-image">
                    <div>
                      <img src="${
                        course.coverImageUrl === ''
                          ? defaultImage
                          : ensureHttps(course.thumbnail)
                      }" alt="${course.name}">
                    </div>
                  </div>
                </div>
                <div class="collection-title">
                  <div class="section-text-header">
                    ${course.name}
                  </div>
                  <div class="section-text">
                    ${course.description ? course.description : ''}
                  </div>
                  
                </div>
                <div class="section-footer">
                    <div class="icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M18.125 4.37502V13.75C18.1245 13.839 18.105 13.9268 18.0678 14.0077C18.0306 14.0885 17.9766 14.1605 17.9094 14.2188C16.7156 15.2524 15.5742 15.625 14.4859 15.625C13.0086 15.625 11.6289 14.9422 10.3453 14.3086C8.27109 13.2813 6.46797 12.3914 4.375 14.0445V17.5C4.375 17.6658 4.30915 17.8247 4.19194 17.942C4.07473 18.0592 3.91576 18.125 3.75 18.125C3.58424 18.125 3.42527 18.0592 3.30806 17.942C3.19085 17.8247 3.125 17.6658 3.125 17.5V4.37502C3.1256 4.28598 3.14522 4.19809 3.18254 4.11725C3.21986 4.03641 3.27403 3.96448 3.34141 3.90627C6.15391 1.47033 8.67812 2.71799 10.9031 3.81877C13.0469 4.8797 14.9055 5.79689 17.0906 3.90627C17.1809 3.82797 17.2918 3.77722 17.4101 3.76003C17.5284 3.74283 17.6491 3.75992 17.758 3.80925C17.8669 3.85859 17.9593 3.93811 18.0243 4.03839C18.0894 4.13866 18.1243 4.25549 18.125 4.37502Z" fill="#E5E7EB"/>
                      </svg>
                    </div>
                    <div class="bar"></div>
                    <div class="label">0%</div>
                  </div>
              </div>
              ${
                isEdit
                  ? `
              <div class="collection-hover-button">
                <button
                  class="edit-collection-button"
                  type="button"
                >
                  ${editIconSvg} Edit card
                </button>
              </div>
              `
                  : ''
              }
            </div>
          </div>
        `,
          )
          .join('')}
      </div>
    `
  }
}
export default CreateCollectionTemplate
